import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-items-for-spring-2022';

export default function Example() {
  return (
    <>
      <Head>
        <title>Spring is Finally Here: What You Should Sell This Season On Poshmark</title>
        <meta
          name='description'
          content='As a new season rolls around, here are the trends and tips you should adopt to refresh your inventory and attract new customers.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-items-for-spring-2022' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-items-for-spring-2022' />
        <meta property='og:title' content='Spring is Finally Here: What You Should Sell This Season On Poshmark' />
        <meta
          property='og:description'
          content='As a new season rolls around, here are the trends and tips you should adopt to refresh your inventory and attract new customers.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
